import { Chip } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { format, parseISO } from "date-fns";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { Dialog } from "../../../components/Dialog";
import { WhatsAppInstance } from "../../../types/whatsApp";
import { checkWhatsAppInstanceConnectionService } from "../../../services/whatsApp";
import { useStyles } from "../styles";

type DetailsWhatsAppProps = {
  data: WhatsAppInstance | null;
  open: boolean;
  onClose: () => void;
};

export function DetailsWhatsApp({ data, open, onClose }: DetailsWhatsAppProps) {
  const styles = useStyles();
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const isConnected = useQuery(
    ["status", data?.id],
    () => checkWhatsAppInstanceConnectionService(data?.id),
    { enabled: open && Boolean(data?.id) }
  );

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="md"
      title={data?.name}
      open={open}
      actions={actions}
    >
      <Stack spacing={4} className={styles.rootContent}>
        <Stack direction="row" spacing={10}>
          <Stack spacing={1} alignItems="center">
            <Typography fontWeight={600}>Loja</Typography>
            <Typography>{data?.id_loja}</Typography>
          </Stack>
          <Stack spacing={1} alignItems="center">
            <Typography fontWeight={600}>Status</Typography>
            {isConnected.isFetching ? (
              <Chip label="Buscando status" />
            ) : (
              <Chip
                color={isConnected.data ? "success" : "error"}
                label={isConnected.data ? "Conectado" : "Desconectado"}
              />
            )}
          </Stack>
          {data?.created_at && (
            <Stack spacing={1} alignItems="center">
              <Typography fontWeight={600}>Data de criação</Typography>
              <Typography>
                {format(
                  parseISO(data?.created_at?.replace("Z", "")),
                  "dd/MM/yyyy"
                )}
              </Typography>
            </Stack>
          )}
          <Stack spacing={1} alignItems="center">
            <Typography fontWeight={600}>Duração do chat</Typography>
            <Typography>{data?.duracao_chat} horas</Typography>
          </Stack>
        </Stack>
        <Stack spacing={1}>
          <Typography fontWeight={600}>Mensagem inicial</Typography>
          <Typography>{data?.mensagem_inicial}</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography fontWeight={600}>Mensagem não entendi</Typography>
          <Typography>{data?.mensagem_nao_entendi}</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography fontWeight={600}>Mensagem finalização chat</Typography>
          <Typography>{data?.mensagem_final_chat}</Typography>
        </Stack>
      </Stack>
    </Dialog>
  );
}
